import { Theme, createTheme } from "@mui/material/styles";

import { getColor } from "@hooks/useColors";
import background_dark from "@public/portfolio_embedded/flares_embedded_dark.png";
import background_light from "@public/portfolio_embedded/flares_embedded_light.png";
import { darkTheme, lightTheme } from "@themes";

const commonTheme = (theme: Theme) => ({
  palette: {
    background: {
      default: getColor(c => c.tokens.bg["weak-50"], theme),
      paper: getColor(c => c.tokens.bg["weak-50"], theme),
    },
  },
  background: {
    image: theme.palette.mode === "light" ? background_light : background_dark,
    blurBox: getColor(c => c.foundations.alpha.blue["alpha-10"], theme),
  },
  footerBackgroundGradient:
    "radial-gradient(44.06% 50% at 50% 0%, rgba(90, 123, 254, 0.08) 0%, rgba(150, 197, 240, 0.04) 100%)",
  card: {
    shadow: getColor(c => c.foundations.blue[400], theme),
  },
  metricCard: {
    color: getColor(c => c.foundations.alpha.blue["alpha-10"], theme),
  },
  portfolio: {
    header:
      theme.palette.mode === "light"
        ? {
            borderColor_100: getColor(c => c.foundations.blue[100], theme),
            borderColor_200: getColor(c => c.foundations.blue[200], theme),
            borderColor_300: getColor(c => c.foundations.blue[300], theme),
          }
        : {
            borderColor_100: "#FFFFFF1A",
            borderColor_200: "#FFFFFF33",
            borderColor_300: "#FFFFFF4D",
          },
    subheader: {
      gradient: getColor(c => c.gradients.embedded.linear, theme),
    },
  },
});

export const embeddedDarkTheme = createTheme(darkTheme, commonTheme(darkTheme));

export const embeddedLightTheme = createTheme(
  lightTheme,
  commonTheme(lightTheme),
);
